export default __webpack_public_path__ + "images/YE.f8eac26.png";